import React, { useEffect, useState } from "react"
import { ChevronRight } from "lucide-react"
import { queryTools } from "lib/utils"


export default function AddPreset({ template }:{ template:any }){

  const savePresetFn = queryTools.resource.save([`preset.template${template._id}.all`])

  const [ newPreset, setNewPreset ] = useState<any>({ subdomain: "", rp: "" })

  const handleInputChange = (e:any) => setNewPreset({ ...newPreset, [e.target.name]: e.target.value })
  const addNewPreset = () => savePresetFn.mutate({ resource: "preset", data: {...newPreset, template_id: template._id} })

  return (
    <form onSubmit={addNewPreset}>
      <div className="w-full flex items-center gap-1 px-2 mt-1">
        <input 
          type="text" 
          name="rp" 
          value={newPreset.rp}
          onChange={handleInputChange}
          placeholder="rp" 
          className="w-2/12 h-6 text-xs border border-solid border-white/50 bg-transparent px-1 placeholder:px-1 placeholder-italic placeholder:opacity-55"
        />
        <input 
          type="text" 
          name="subdomain" 
          value={newPreset.subdomain}
          onChange={handleInputChange}
          placeholder="subdomain" 
          className="w-8/12 h-6 text-xs border border-solid border-white/50 bg-transparent px-1 placeholder:px-1 placeholder-italic placeholder:opacity-55" 
        />
        <button 
          type="submit"
          className="w-1/12 flex justify-center items-center h-6 ml-2 mr-2 stroke-1 cursor-pointer stroke-white border border-solid border-white/50"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
      
    </form>
  )
}